 
<template>
  <div class="settings-wrapper py-5 min-vh-100 bg-light">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          
          <div class="d-flex justify-content-between align-items-center mb-5">
            <div>
              <h2 class="fw-bold mb-1 text-dark">Control Panel</h2>
              <p class="text-muted small">Manage your account and individual settings</p>
            </div>
            <button @click="$router.push('/dashboard')" class="btn btn-dark btn-dashboard shadow-sm">
              <i class="fas fa-th-large me-2"></i>Dashboard
            </button>
          </div>

          <div class="settings-card mb-4 border-0 shadow-sm rounded-4 overflow-hidden bg-white border">
            <div class="card-header-gradient p-3 text-white d-flex align-items-center">
              <i class="fas fa-user-cog me-2"></i>
              <span class="fw-bold">Account Configuration</span>
            </div>
            <div class="card-body p-4">
              <div class="row g-3 mb-3">
                <div class="col-md-6">
                  <label class="form-label small fw-bold opacity-75">User Name</label>
                  <input type="text" v-model="user.name" class="form-control bg-light" placeholder="Username">
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label small fw-bold opacity-75">Change Password</label>
                <div class="input-group">
                  <input :type="showPassword ? 'text' : 'password'" v-model="user.password" class="form-control bg-light border-end-0" placeholder="New password">
                  <span class="input-group-text bg-light border-start-0 cursor-pointer" @click="showPassword = !showPassword">
                    <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" class="text-muted"></i>
                  </span>
                </div>
              </div>
              <div class="text-end border-top pt-3">
                <button @click="updateProfile" class="btn btn-primary-gradient px-4 rounded-pill">Update Profile</button>
              </div>
            </div>
          </div>

          <div class="settings-card mb-4 border-0 shadow-sm rounded-4 bg-white border overflow-hidden">
             <div class="card-header bg-white border-0 p-4 pb-0">
               <h6 class="fw-bold mb-0 text-primary"><i class="fas fa-robot me-2"></i>AI Connectivity</h6>
             </div>
            <div class="card-body p-4">
              <div class="row g-3">
                <div class="col-12 col-md-7">
                  <label class="form-label small fw-bold opacity-75">Groq API Key</label>
                  <div class="input-group">
                    <input :type="showKey ? 'text' : 'password'" v-model="settings.apiKey" class="form-control bg-light" placeholder="gsk_...">
                    <button class="btn btn-light border" @click="showKey = !showKey">
                       <i :class="showKey ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                    </button>
                  </div>
                </div>
                <div class="col-12 col-md-5">
                  <label class="form-label small fw-bold opacity-75">Selected Model</label>
                  
                  <select v-model="settings.aiModel" class="form-select bg-light h-auto py-2">
                  <option value="llama-3.3-70b-versatile">Llama 3.3 70B</option>
  
                    <option value="llama-3.1-8b-instant">Llama 3.1 8B</option>
  
                      <option value="mixtral-8x7b-32768">Mixtral 8x7b</option>
</select>
                </div>
              </div>
              <div class="text-end border-top mt-3 pt-3">
                <button @click="saveAISettings" class="btn btn-primary px-4 rounded-pill">Save AI Config</button>
              </div>
            </div>
          </div>

          <div class="settings-card mb-4 border-0 shadow-sm rounded-4 bg-white border overflow-hidden">
            <div class="card-body p-4">
              <h6 class="fw-bold mb-4 text-danger"><i class="fas fa-exclamation-triangle me-2"></i>Danger Zone</h6>
              
              <div class="mb-4 pb-4 border-bottom">
                <p class="mb-2 fw-bold small">Manage Specific Group</p>
                <div class="d-flex flex-wrap gap-2">
                  <div class="flex-grow-1" style="min-width: 200px;">
                    <WorkSpaceSwitcher v-model="selectedGroupId" :key="switcherKey"/>
                  </div>
                  <div class="d-flex gap-2">
                    <button @click="editGroupName" class="btn btn-outline-primary" :disabled="!selectedGroupId">
                      <i class="fas fa-edit"></i>
                    </button>
                    <button @click="deleteSpecificGroup" class="btn btn-outline-danger" :disabled="!selectedGroupId">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
                <div>
                  <p class="mb-0 fw-bold small">Terminate Account</p>
                  <small class="text-muted">Delete your entire account and all configurations permanently.</small>
                </div>
                <button @click="deleteAccount" class="btn btn-danger px-4 rounded-pill shadow-sm">Delete Account</button>
              </div>
            </div>
          </div>

          <div class="settings-card mb-5 border-0 shadow-sm rounded-4 overflow-hidden bg-white border">
            <div class="list-group list-group-flush border-0">
              <button @click="activeModal = 'privacy'" class="list-group-item list-group-item-action p-3 d-flex justify-content-between align-items-center">
                <span><i class="fas fa-user-shield me-2 text-warning"></i> Privacy Policy</span>
                <i class="fas fa-chevron-right small opacity-50"></i>
              </button>
              <button @click="activeModal = 'license'" class="list-group-item list-group-item-action p-3 d-flex justify-content-between align-items-center">
                <span><i class="fas fa-file-signature me-2 text-info"></i> Commercial License</span>
                <i class="fas fa-chevron-right small opacity-50"></i>
              </button>
            </div>
          </div>

         
  <div v-if="activeModal" class="custom-modal-overlay d-flex align-items-center justify-content-center p-3" @click.self="activeModal = null">
  <div class="custom-modal-content rounded-4 shadow-xl p-4 bg-white border animate__animated animate__zoomIn animate__faster">
    
    <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
      <h5 class="fw-bold mb-0 text-primary">
        <i :class="activeModal === 'privacy' ? 'fas fa-user-shield' : 'fas fa-file-contract'" class="me-2"></i>
        {{ activeModal === 'privacy' ? 'Privacy Policy' : 'License Agreement' }}
      </h5>
      <button @click="activeModal = null" class="btn-close shadow-none"></button>
    </div>

    <div class="modal-body-scrollable pe-2">
      <div v-if="activeModal === 'privacy'" class="policy-text">
        <p class="text-muted mb-2">Last Updated: January 2026</p>
        <h6>1. Introduction</h6>
        <p>Welcome to AI Strategy Hub. We are committed to protecting your personal data and your privacy. This Privacy Policy explains how our application processes information when you use our AI-powered task analysis features.</p>
        
        <h6>2. Data Processing (AI & Logic)</h6>
        <div>Our application uses the Groq Cloud API and Llama 3.1 models. 
          <ul>
            <li><strong>Input Data:</strong> Only task titles and descriptions are sent to the AI engine.</li>
            <li><strong>Encryption:</strong> Data is transmitted via SSL/TLS protocols and protected against SQL Injection.</li>
            <li><strong>No Training:</strong> We do not use your private data to train global AI models.</li>
          </ul>
        </div>
        
        <h6>3. Data Storage</h6>
        <p>Your API keys and preferences are stored locally on your device (LocalStorage). Task analyses are stored in your private database, secured with modern hashing and encryption.</p>
        
        <h6>4. Contact</h6>
        <p>Developer: <strong>Dirar</strong><br>Email: diraribnsalah@gmail.com</p>
      </div>

      <div v-else class="policy-text">
        <h6>1. Commercial License</h6>
        <p>This software is provided under a Commercial Use License. You are granted the right to use, modify, and integrate this platform into your business workflow.</p>
        
        <h6>2. Security & Liability</h6>
        <p>While we implement industry-standard security measures (Bcrypt for passwords, Parameterized Queries for database safety), the developer is not liable for data loss resulting from user-side API key exposure.</p>
        
        <h6>3. Third-Party Libraries</h6>
        <p>This project utilizes open-source components including Node.js, Vue.js, and Bootstrap 4. Use of these components is governed by their respective MIT/Apache licenses.</p>
        
        <h6>4. Restrictions</h6>
        <p>Redistribution of this specific source code as a standalone "template" for resale is prohibited without explicit developer consent.</p>
      </div>
    </div>

    <div class="text-end mt-4">
      <button @click="activeModal = null" class="btn btn-primary px-4 btn-sm rounded-pill">I Understand</button>
    </div>
  </div>
</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WorkSpaceSwitcher from '@/components/WorkSpaceSwitcher.vue';
import {usersService} from "@/services/userService.js";
import { groupsService } from '@/services/groupsService';
import Swal from 'sweetalert2';

export default {
  components: { WorkSpaceSwitcher },
  data() {
    return {
      showKey: false,
      showPassword: false,
      activeModal: null,
      selectedGroupId: null,
      switcherKey: 0,
      user: { name: 'User', password: '' },
      settings: {
        apiKey: localStorage.getItem('user_groq_key') || '',
        aiModel: localStorage.getItem('user_ai_model') || 'llama-3.1-70b-versatile'
      }
    };
  },
  methods: {
 async updateProfile() {
   
  if (!this.user.name || this.user.name.trim().length < 3) {
      Swal.fire({
      icon: 'warning',
      title: 'Weak username',
      text: 'the password must be at least 3 characters long.',
      confirmButtonColor: '#6366f1'
    });
    return;
  }

  
  if (this.user.password && this.user.password.length < 6) {
    Swal.fire({
      icon: 'warning',
      title: 'Weak Password',
      text: 'For your security, the password must be at least 6 characters long.',
      confirmButtonColor: '#6366f1'
    });
    return;
  }

  try {
    Swal.fire({ 
      title: 'Updating Profile...', 
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading() 
    });

     
    await usersService.updateProfile(this.user.name, this.user.password);
    
    this.user.password = '';  
    Swal.fire({ icon: 'success', title: 'Updated Successfully!', timer: 2000, showConfirmButton: false });
    
  } catch (err) {
    const errorMessage = err.response?.data || 'Something went wrong.';
    Swal.fire({
      icon: 'error',
      title: 'Update Failed',
      text: typeof errorMessage === 'string' ? errorMessage : (errorMessage.message || 'Validation error'),
      confirmButtonColor: '#ef4444'
    });
  }
},

    saveAISettings() {
      localStorage.setItem('user_groq_key', this.settings.apiKey);
      localStorage.setItem('user_ai_model', this.settings.aiModel);
       Swal.fire({ icon: 'success', title: 'saved successfully!', timer: 4000, showConfirmButton: true });
    },

    async editGroupName() {
      if (!this.selectedGroupId) return;
      const { value: newName } = await Swal.fire({
        title: 'Rename Workspace',
        input: 'text',
        inputPlaceholder: 'New name...',
        showCancelButton: true,
        confirmButtonColor: '#6366f1',
        inputValidator: (value) => !value && 'You must enter a name!'
      });

      if (newName) {
        try {
          await groupsService.updateGroup(this.selectedGroupId, { name: newName });
          this.switcherKey++;
          this.triggerToast('Workspace renamed!');
        } catch (err) {
          Swal.fire('Error', 'Failed to update', 'error');
        }
      }
    },

    async deleteSpecificGroup() {
      const result = await Swal.fire({
        title: 'Delete Group?',
        text: "This action cannot be undone!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        confirmButtonText: 'Yes, delete it'
      });

      if (result.isConfirmed) {
        try {
          await groupsService.deleteGroup(this.selectedGroupId);
          this.selectedGroupId = null;
          Swal.fire({
  toast: true,
  position: 'top-end',
  icon: 'success',
  title: 'Group deleted successfully',
  showConfirmButton: false,
  timer: 3000
});
          this.switcherKey++;
        } catch (err) {
           Swal.fire('Error', err.response?.data || 'Delete failed', 'error');
        }
      }
    },

    async deleteAccount() {
      const result = await Swal.fire({
        title: 'DELETE ACCOUNT?',
        text: "This will wipe all your data forever!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        confirmButtonText: 'Goodbye, Delete My Account'
      });

      if (result.isConfirmed) {
        try {
          
           await  usersService.deleteAccount();
          localStorage.clear();
          this.$router.push('/login');
        } catch (err) {
          Swal.fire('Error', 'Could not delete account', 'error');
        }
      }
    },

     
    
  }
};
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
.card-header-gradient { background: linear-gradient(90deg, #6366f1, #a855f7); }
.btn-primary-gradient { background: linear-gradient(135deg, #6366f1, #4f46e5); color: white; border: none; }
.custom-modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); z-index: 1050; backdrop-filter: blur(4px); }
.custom-modal-content { width: 100%; max-width: 500px; }

/* Responsive adjustments */
@media (max-width: 576px) {
  .btn-dashboard { padding: 6px 12px; font-size: 0.8rem; }
  .settings-card { border-radius: 12px !important; }
}

.custom-toast {
  position: fixed; bottom: 30px; left: 50%; transform: translateX(-50%);
  padding: 12px 24px; border-radius: 50px; color: white; z-index: 9999;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15); display: flex; align-items: center; min-width: 250px;
}
.toast-success { background: #10b981; }
.toast-error { background: #ef4444; }
.modal-body-scrollable {
  max-height: 400px;
  overflow-y: auto;
  font-size: 0.875rem;  
  line-height: 1.5;
  color: #444;
}

.policy-text h6 {
  font-weight: 700;
  margin-top: 1.2rem;
  color: #2c3e50;
  border-left: 3px solid #6366f1;
  padding-left: 8px;
}

.custom-modal-content {
  max-width: 600px;  
  width: 100%;
}
</style>